export default {
  CAMPAIGNS: {
    // CAMPAIGN FORM. 
    CAMPAIGN_NAME: {
      title: "Campaign Name",
      text: `Choose a suitable name for your campaign. Your campaign name is a key identifier for users to find your campaign.`,
    },
    VISION_STATEMENT: {
      title: "Vision Statement",
      text: "Write a brief description about the nature and intention of the campaign to help user’s know what the campaign is about in a broad sense. ",
    },
    PROFILE_IMAGE: {
      title: "Campaign Profile Photo",
      text: "Upload a profile photo for your campaign. This photo will be displayed on your campaign page and in search results.",
    },
    COVER_IMAGE: {
      title: "Campaign Cover Photo",
      text: "Upload a cover photo for your campaign. This photo will be displayed on your campaign page.",
    },
    VALUES: {
      title: "Campaign Values/Principles",
      text: "Connect values which are associated with the campaign. You may attach P4P’s community values or add your own. Attaching values helps user’s to know and understand if this campaign is a good fit.",
    },
    AIMS: {
      title: "Campaign Aims",
      text: "Attach qualitative aims which you are hoping to pursue in association with this campaign.",
    },
    BACKGROUND: {
      title: "Campaign Background",
      text: "Provide a detailed background of the campaign, explaining the problem the campaign is addressing, why the campaign is important and how the campaign intends to address the problem.",
    },
    MISSION: {
      title: "Campaign's Mission Statement",
      text: "Clearly outline a short description of how the campaign is intending to tackle the issue you’ve outlined in the background. ",
    },
    COMMITMENT: {
      title: "Campaign Commitment",
      text: "Summarise your mission into a single statement about what you are committing to doing.",
    },
    LOCATION: {
      title: "Campaign Location",
      text: " Attach the location of where the campaign is operating, you may choose up to five locations if it is operating in multiple areas. ",
    },
    TAGS: {
      title: "Campaign Tags",
      text: "Attach tags which are associated with the nature of the campaign. This can be used to help users find campaigns they are looking for.",
    },
    CONTACT_INFORMATION: {
      title: "Campaign Contact Information",
      text: "Attach contact info for individuals to able to communicate with you outside of the platform.",
    },
    LINKS: {
      title: "Campaign Links",
      text: "Attach external links. ‘Link name’ is the text displayed for the link, the ‘link url’ is the url the user will be redirected to upon clicking the link. ",
    },
    CREATORS: {
      title: "Campaign Creators",
      text: "Add Campaign co-creators. Co-creators are people you have been collaborating with in the conception of this campaign. Add creators by typing their phone number into the input displayed, creators must be registered on P4P to be added.",
    },
    MAINTAINERS: {
      title: "Campaign Maintinaers",
      text: "Add campaign maintainers to join you in ensuring the wellbeing of the campaign. Maintainers must be user’s who are already registered on the account. Add maintainers by typing their phone number into the input field displayed. ",
    },
    MEMBERSHIP: {
      title: 'Campaign Membership',
      text: "Joining a Campaign is a means of showing support, whilst permitting you access to the campaign's campsite to provide you with more ways to engage in this campaign. "
    }
  },
  FUNDRAISING: {
    PLATFORM_DONATION: {
      title: "Platform Donation"
    }
  }
};
